const { createContext, useContext, useRef, memo } = React;
export const StreamingTextContext = createContext(false);
export const StreamText = memo(function StreamText({ text }) {
  const streaming = useContext(StreamingTextContext), memory = useRef({ text: '', runs: [] });
  if (!streaming && !memory.current.runs.length) { memory.current = { text, runs: [] }; return text; }
  const previous = memory.current;
  if (text !== previous.text) {
    const prefix = text.startsWith(previous.text), start = prefix ? previous.text.length : 0;
    const runs = prefix ? previous.runs.slice(-31) : [];
    runs.push({ start, text: text.slice(start) }); memory.current = { text, runs };
  }
  const runs = memory.current.runs;
  return <>{text.slice(0, runs[0]?.start ?? text.length)}{runs.map(run => <span className="ai-text-arrival" key={run.start}>{run.text}</span>)}</>;
});
